var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.488 12.082 4.57-4.57q.105-.141.106-.317a.38.38 0 0 0-.105-.28l-.809-.81A.38.38 0 0 0 16.969 6a.5.5 0 0 0-.317.105l-4.57 4.57-4.57-4.57A.5.5 0 0 0 7.195 6a.38.38 0 0 0-.28.105l-.81.81a.38.38 0 0 0-.105.28q0 .176.105.317l4.57 4.57-4.57 4.57A.5.5 0 0 0 6 16.97q0 .175.105.281l.81.809a.38.38 0 0 0 .28.105.5.5 0 0 0 .317-.105l4.57-4.57 4.57 4.57q.141.105.317.105a.38.38 0 0 0 .281-.105l.809-.809a.38.38 0 0 0 .105-.281.5.5 0 0 0-.105-.317z"
  })));
};
export default SvgClose;